export function Checkbox({
  label,
  value,
  onClick,
  className,
  checked,
  disabled,
}: {
  label: string | React.ReactNode;
  value?: string;
  onClick: (value: boolean) => void;
  className?: string;
  checked?: boolean;
  disabled?: boolean;
}) {
  return (
    <label
      className={`${disabled ? "text-gray-400 cursor-not-allowed" : "text-gray-500"} ${className}`}
    >
      <input
        checked={!!checked}
        disabled={disabled}
        type="checkbox"
        value={value}
        onChange={(e) => onClick(!e.target.checked)}
      />
      {label}
    </label>
  );
}
